import type { Ref } from 'preact';
import type { FC, ReactNode } from 'preact/compat';

import { Spinner } from '@vkontakte/vkui';
import useInfiniteScroll from 'react-infinite-scroll-hook';

import { ROOT_MARGIN } from './InfiniteScroll.constants';

import styles from './styles.module.css';

interface Props {
  children: ReactNode;
  isLoading: boolean;
  hasNextPage: boolean;
  onLoadMore: () => void;
  listRef?: Ref<HTMLDivElement>;
}

export const InfiniteScroll: FC<Props> = ({ children, listRef, isLoading, hasNextPage, onLoadMore }) => {
  const [infiniteRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage,
    onLoadMore,
    disabled: !hasNextPage,
    rootMargin: ROOT_MARGIN,
  });

  // Флажок показа триггера для дальнейшей загрузки данных
  const showTrigger = isLoading || hasNextPage;

  return (
    <div className={styles.list} ref={listRef}>
      {children}
      {showTrigger && (
        <div className={styles.trigger} ref={infiniteRef}>
          {isLoading && <Spinner size="s" />}
        </div>
      )}
    </div>
  );
};
